import { render, staticRenderFns } from "./StudentExamList.vue?vue&type=template&id=1e630e28&scoped=true&"
import script from "./StudentExamList.vue?vue&type=script&scoped=true&lang=js&"
export * from "./StudentExamList.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./StudentExamList.vue?vue&type=style&index=0&id=1e630e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e630e28",
  null
  
)

export default component.exports